import { Component, EventEmitter, Output, inject, signal, computed, ChangeDetectionStrategy } from '@angular/core';
import { trigger, style, animate, transition } from '@angular/animations';
import { Router, RouterLink } from '@angular/router';
import { NgOptimizedImage } from '@angular/common';
import { toSignal } from '@angular/core/rxjs-interop';

import { Category } from '../../new-equipment/models/categories.model';
import { UsedEquipmentCategory } from '../../used-equipment/models/used-categories.model';

import { NewEquipmentService } from '../../services/new-equipment.service';
import { UsedEquipmentService } from '../../services/used-equipment.service';

@Component({
  selector: 'app-mega-menu-equipments',
  templateUrl: './mega-menu-equipments.component.html',
  styleUrl: './mega-menu-equipments.component.scss',
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [
        style({ opacity: 0, maxWidth: '0px' }),
        animate('300ms ease', style({ opacity: 1, maxWidth: '296px' })),
      ]),
      transition(':leave', [animate('300ms ease', style({ opacity: 0, maxWidth: '0px' }))]),
    ]),
  ],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, NgOptimizedImage],
})
export class MegaMenuEquipmentsComponent {
  private router = inject(Router);
  private readonly newEquipmentService = inject(NewEquipmentService);
  private readonly usedEquipmentService = inject(UsedEquipmentService);

  @Output() closeMenu = new EventEmitter<void>();

  readonly activeIndex = signal<number>(0);

  private readonly newCategoriesData = toSignal(this.newEquipmentService.getCategories(0, 0, ''));
  private readonly usedCategoriesData = toSignal(this.usedEquipmentService.getAllCategories());

  readonly newCategories = computed<Category[]>(() => this.newCategoriesData()?.results ?? []);
  readonly usedCategories = computed<UsedEquipmentCategory[]>(() => this.usedCategoriesData()?.results ?? []);

  onMouseEnter(index: number): void {
    this.activeIndex.set(index);
  }

  closeMainMenu(): void {
    this.activeIndex.set(0);
    this.closeMenu.emit();
  }

  checkHover(): void {
    this.activeIndex.set(0);
  }

  goToRent(): void {
    this.closeMainMenu();
    this.router.navigate(['/renta']);
  }
}
